/**
 * calcDatas
 * 
 * Возвращает дату в формате ISO 8601 в текущей локали (временном поясе)
 * 
 * @param {String} mode - желаемая дата: 
 * - now    : текущее время
 * - tBegin : начало сегодняшнего дня
 * - yBegin : начало вчерашнего дня
 * - yEnd   : конец вчерашнего дня
 * 
 * @returns {String} - дата в формате ISO 8601 
 */

export default function calcDatas(mode = '', timestamp = null) {

    const d = timestamp ? new Date(timestamp) : new Date()

    switch(mode) {

        // Today begin
        case 'tBegin': 
            d.setHours(0)
            d.setMinutes(0)
            d.setSeconds(0)
            break

        // Today end
        case 'tEnd': 
            d.setHours(23)
            d.setMinutes(59)
            d.setSeconds(59)
            break

        // Yesterday begin
        case 'yBegin': 
            d.setDate(d.getDate() - 1)
            d.setHours(0)
            d.setMinutes(0)
            d.setSeconds(0)
            break

        // Yesterday end
        case 'yEnd': 
            d.setDate(d.getDate() - 1)
            d.setHours(23)
            d.setMinutes(59)
            d.setSeconds(59)
            break

        // Week ago
        case 'week': 
            d.setDate(d.getDate() - 7)
            break

        // Month ago
        case 'month': 
            d.setMonth(d.getMonth() - 1)
            d.setHours(0)
            d.setMinutes(0)
            d.setSeconds(0)
            break

        // Century ago
        case 'century': 
            d.setFullYear(d.getFullYear() + 100)
            d.setHours(0)
            d.setMinutes(0)
            d.setSeconds(0)
            break
    }

    d.setMinutes(d.getMinutes() - d.getTimezoneOffset())

    return d.toISOString().slice(0,16)
}